import {DisconnectOutlined} from '@ant-design/icons';
import {Tag, Tooltip} from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import {AdminMarketplace} from '../../../../gen/api/models';
import {marketplaceLabel} from '../../../helpers/status';

export const brokenLinkDescription = (linkBrokenAt: string) =>
    `The listing is no longer available at this link: it ended, sold out or was removed. ` +
    `Found by the daily check on ${dayjs(linkBrokenAt).format('MM/DD/YYYY')}. ` +
    `Changing the link removes this mark until the next check.`;

interface BrokenLinkTagProps {
    marketplace: AdminMarketplace;
}

/** Red tag of a listing whose link no longer leads to it; opens the link. */
export const BrokenLinkTag: React.FC<BrokenLinkTagProps> = ({marketplace}) => {
    if (!marketplace.linkBrokenAt) {
        return null;
    }
    return (
        <Tooltip title={brokenLinkDescription(marketplace.linkBrokenAt)}>
            <a
                href={marketplace.link}
                target={'_blank'}
                rel={'noreferrer'}
            >
                <Tag
                    color={'red'}
                    icon={<DisconnectOutlined />}
                    style={{marginRight: 0}}
                >
                    {marketplaceLabel(marketplace.name)}: broken link
                </Tag>
            </a>
        </Tooltip>
    );
};
